// @flow
import { takeEvery, put, call } from 'redux-saga/effects';
import { fetchDeliveryResourcesSuccess } from './actions';
import { tripica } from '../../api';
import HandleErrorService from '../../lib/handleError';
import WizzeeLog from '../../lib/wizzeeLog';

export function* getDeliveryResources(): Generator<*, *, *> {
  try {
    const resourceDeliveries = yield call([tripica, 'getResourceDeliveries']);

    if (resourceDeliveries.length) {
      const resources = resourceDeliveries
        .map(resource => ({
          ouid: resource.ouid,
          orderDate: resource.startDateTime,
          status: resource.status,
          deliveryId: resource.deliveryId,
          deliveryMethod: resource.deliveryMethod,
          deliveryAddress: resource.deliveryAddress,
          isLinkedWithActivableSubscription: true,
          productOuid: resource.productOuid,
          trackingLink: resource.trackingLink,
          trackingId: resource.characteristics && resource.characteristics.DELIVERY_TRACKING_NUMBER,
          deliveryName: resource.characteristics && resource.characteristics.DELIVERY_NAME,
        }))
        .sort((resourceA, resourceB) => resourceB.orderDate - resourceA.orderDate);
      yield put(fetchDeliveryResourcesSuccess(resources));
    }
  } catch (e) {
    HandleErrorService.showToastError(e);
    WizzeeLog.warn('[saga] getDeliveryResources', e);
  }
}

export default function*(): Generator<*, *, *> {
  yield takeEvery('FETCH_DELIVERY_RESOURCES', getDeliveryResources);
}
